const videoHeroes = document.querySelectorAll('.block-video-hero');

if (videoHeroes) {
	videoHeroes.forEach((videoHero) => {
		const video = videoHero.querySelector('video');
		const playButton = videoHero.querySelector('.block-video-hero__play-button');

		if (video && playButton) {
			playButton.addEventListener('click', () => {
				if (video.paused) {
					video.play();
					playButton.classList.add('is-playing');
				} else {
					video.pause();
					playButton.classList.remove('is-playing');
				}
			});
		}
	});
}
